import { render, staticRenderFns } from "./GuiaPendencias.vue?vue&type=template&id=3b7e1530&"
import script from "./GuiaPendencias.vue?vue&type=script&lang=js&"
export * from "./GuiaPendencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports